import texts from "../data/text.json";
import InfoPanel from  "./InfoPanel";

export default function Studio({ lang }) {
  const section = texts.sections.find((s) => s.id === "studio");
  if (!section) return null;

return (
  <>
    {section.chapter.map((chap, index) => {
      const isSpecial = index === 1; // par exemple, le 3e panneau

      return (
        <InfoPanel
          key={index}
          position={[-index * 5, 0.5, 0]}
          title={chap.title[lang]}
          content={chap.content[lang]}
          variant={isSpecial ? "special" : "default"} // 👈 nouvelle prop
        />
      );
    })}
  </>
);
}
